module.exports = __webpack_public_path__ + "assets/img/touxiang-2.0d953f92.png";